module.exports = __webpack_public_path__ + "img/input-count-minus-disable.27bbffa5.svg";